import React from 'react';
import { Icon, Tooltip } from '@aidkitorg/component-library';
import type { ProviderErrorDetail } from '@aidkitorg/types/lib/messaging/providerError';

/**
 * One-line `code · description` for an undelivered/failed message, truncated to fit, with the
 * full text on hover or keyboard focus and a link to Twilio's error reference when there is one.
 */
export function ProviderErrorSummary({ error, className }: { error: ProviderErrorDetail, className?: string }) {
  const summary = [error.code, error.description].filter(Boolean).join(' · ');
  return (
    <span className={`inline-flex min-w-0 max-w-full items-center gap-1 text-red-700 ${className ?? ''}`}>
      <Tooltip text={summary} asChild>
        <button type="button" className="min-w-0 truncate text-left">{summary}</button>
      </Tooltip>
      {error.docsUrl && (
        <a
          href={error.docsUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Twilio error ${error.code} reference`}
          className="shrink-0 hover:text-red-900"
        >
          <Icon name="ArrowTopRightOnSquareIcon" size="sm" role="decorative" />
        </a>
      )}
    </span>
  );
}
